import { render, staticRenderFns } from "./DialogAddEmergencyContact.vue?vue&type=template&id=0cb01608"
import script from "./DialogAddEmergencyContact.vue?vue&type=script&lang=js"
export * from "./DialogAddEmergencyContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports